// Formas de pagamento do pedido com valor, como a tela de Pedidos mostra e filtra.
//
// O servidor manda `pagamento_partes` = [{chave, nome, forma, valor}] (uma linha
// por forma usada; regra em backend/services/formas_pedido.py). Pedido dividido
// vem como "Dinheiro R$ 50,00 + Cartão R$ 50,00" — "Múltiplo" não existe mais
// para o lojista (dono, 24/09/2026). A `chave` é a mesma do filtro do resumo,
// então lista e resumo concordam sobre em qual forma cada pedido caiu.

import { rotuloPagamento } from "./pagamentoRotulo";

const centavos = (v) => Math.round((Number(v) || 0) * 100);

export const formatarReais = (v) =>
  `R$ ${(Number(v) || 0).toFixed(2).replace(".", ",")}`;

// Payload antigo (sem o campo): uma forma só, com o total.
export function partesDoPedido(pedido) {
  // Lista vazia é resposta: rodada zerada (cashback, desconto) sem parte
  if (Array.isArray(pedido?.pagamentoPartes)) return pedido.pagamentoPartes;
  const nome = rotuloPagamento(pedido?.formaPagamento);
  return [{ chave: nome, nome, forma: pedido?.formaPagamento || "", valor: Number(pedido?.total) || 0 }];
}

/** Soma as formas de vários pedidos (sessão de mesa com várias rodadas). */
export function juntarPartes(listas) {
  const porChave = new Map();
  listas.flat().forEach((p) => {
    const atual = porChave.get(p.chave) || { ...p, valor: 0 };
    atual.valor = (centavos(atual.valor) + centavos(p.valor)) / 100;
    porChave.set(p.chave, atual);
  });
  return [...porChave.values()];
}

/** O pedido entra no filtro se ALGUMA forma usada estiver marcada. */
export const casaFiltroPagamento = (partes, chaves) => partes.some((p) => chaves.includes(p.chave));

/** Texto de uma célula (Excel): "Dinheiro R$ 50,00 + Cartão R$ 50,00". */
export function textoPartes(partes) {
  if (partes.length <= 1) return partes[0]?.nome || "—";
  return partes.map((p) => `${p.nome} ${formatarReais(p.valor)}`).join(" + ");
}
